export const SET_PRICES = 'SET_PRICES';